var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "male_Avatar",
    "data-name": "male Avatar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.999,
    height: 68.998,
    viewBox: "0 0 68.999 68.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21268",
    "data-name": "Path 21268",
    d: "M345.054,307.713a34.5,34.5,0,1,1-34.5-34.5A34.373,34.373,0,0,1,345.054,307.713Z",
    transform: "translate(-276.056 -273.216)",
    fill: "rgba(16,135,87,0.1)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21237",
    "data-name": "Path 21237",
    d: "M345.055,307.713a34.5,34.5,0,1,1-34.5-34.5A34.373,34.373,0,0,1,345.055,307.713Z",
    transform: "translate(-276.056 -273.216)",
    fill: "rgba(16,135,87,0.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_55",
    "data-name": "Mask Group 55",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19635",
    "data-name": "Group 19635",
    transform: "translate(-1.549 10.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21238",
    "data-name": "Path 21238",
    d: "M362.648,309.971v14.035h-34.32V309.971a13.263,13.263,0,0,1,.409-3.3,13.533,13.533,0,0,1,13.129-10.234h7.244A13.532,13.532,0,0,1,362.648,309.971Z",
    transform: "translate(-309.451 -296.44)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M0,65.494l.864-3.4A14.173,14.173,0,0,1,11.32,51.8l8.572-2.047a10.921,10.921,0,0,0,2.072-.734.508.508,0,0,0,.09-.05,10.383,10.383,0,0,0,5.48-6.736l.672-2.592.175-.7c-.789-.766-1.6-1.623-2.489-2.521-1.171-1.172-2.13-3.98-2.953-7.472-.042-.177-.094-.395-.146-.641a8.656,8.656,0,0,1-.816.534c-1.592.919-3.326-2.053-4.209-5.024-1.108-3.751-.855-7.5,2.777-3.429a11.619,11.619,0,0,1,.983.7c-.363-2.591-.545-4.448-.545-4.448-.044-.493-.071-1.007-.071-1.52,0-.132.008-.267.008-.4a15.1,15.1,0,0,1,.486-3.454l.04-.153A15.145,15.145,0,0,1,35.169.025c.286-.018.57-.025.862-.025A15.113,15.113,0,0,1,51.163,15.126a13.17,13.17,0,0,1-.1,1.634c-.042.434-.215,2.112-.526,4.33a11.862,11.862,0,0,1,.979-.7c3.627-4.075,3.879-.323,2.771,3.429-.879,2.972-2.617,5.943-4.209,5.024a8.179,8.179,0,0,1-.8-.527c-.778,3.527-1.809,6.81-3.105,8.106-.9.9-1.7,1.755-2.489,2.521l.182.7.672,2.586a10.423,10.423,0,0,0,5.48,6.741,10.668,10.668,0,0,0,2.162.78L60.749,51.8A14.191,14.191,0,0,1,71.2,62.1l.864,3.4A50.048,50.048,0,0,1,0,65.494Z",
    transform: "translate(0 4.688)",
    fill: "#b6ddcf",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21244",
    "data-name": "Path 21244",
    d: "M356.67,351.325a2.439,2.439,0,0,1-4.752,0,1.194,1.194,0,0,1,.05-.367,2.537,2.537,0,0,0,4.651,0A1.19,1.19,0,0,1,356.67,351.325Z",
    transform: "translate(-318.194 -316.646)",
    fill: "#7ab59f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19633",
    "data-name": "Group 19633",
    transform: "translate(23.326 22.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19630",
    "data-name": "Group 19630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21245",
    "data-name": "Path 21245",
    d: "M340.9,342.507a5.5,5.5,0,1,1,5.5-5.5A5.509,5.509,0,0,1,340.9,342.507Zm0-10.375A4.873,4.873,0,1,0,345.773,337,4.879,4.879,0,0,0,340.9,332.131Z",
    transform: "translate(-335.397 -331.502)",
    fill: "#7ab59f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19631",
    "data-name": "Group 19631",
    transform: "translate(14.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21246",
    "data-name": "Path 21246",
    d: "M363.786,342.507a5.5,5.5,0,1,1,5.5-5.5A5.509,5.509,0,0,1,363.786,342.507Zm0-10.375A4.873,4.873,0,1,0,368.659,337,4.879,4.879,0,0,0,363.786,332.131Z",
    transform: "translate(-358.283 -331.502)",
    fill: "#7ab59f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19632",
    "data-name": "Group 19632",
    transform: "translate(10.376 3.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21247",
    "data-name": "Path 21247",
    d: "M356.54,338.874h-.629a1.7,1.7,0,1,0-3.4,0h-.629a2.329,2.329,0,1,1,4.657,0Z",
    transform: "translate(-351.883 -336.545)",
    fill: "#7ab59f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_21248",
    "data-name": "Path 21248",
    d: "M362.648,311.728v9.548l-2.65,2.7-5.419-15.5H336.4l-5.419,15.5-2.65-2.7v-9.548a13.263,13.263,0,0,1,.409-3.3l1.542-.963,11.612-4.8,3.6-1.485,3.594,1.485,11.612,4.8,1.542.963A13.26,13.26,0,0,1,362.648,311.728Z",
    transform: "translate(-309.451 -298.197)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21249",
    "data-name": "Path 21249",
    d: "M370.4,398.227a50.32,50.32,0,0,1-10.038,8.037,49.125,49.125,0,0,1-5.822,3.04,50.157,50.157,0,0,1-40.217.057,48.854,48.854,0,0,1-5.815-3.015,50.154,50.154,0,0,1-10.171-8.119l.862-3.4a14.179,14.179,0,0,1,9.308-9.969c.378-.126.755-.233,1.145-.327l4.67-1.114,3.9-.932a10.5,10.5,0,0,0,2.071-.736.694.694,0,0,0,.094-.05l14.041,14.57,13.915-14.564a10.421,10.421,0,0,0,2.165.78l4.028.963,4.544,1.082c.434.107.862.227,1.278.371a14.19,14.19,0,0,1,9.176,9.925Z",
    transform: "translate(-298.336 -328.04)",
    fill: "rgba(16,135,87,0.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19634",
    "data-name": "Group 19634",
    transform: "translate(10.173 55.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21250",
    "data-name": "Path 21250",
    d: "M320.313,384.43v25.943a48.865,48.865,0,0,1-5.815-3.015V385.871c.378-.126.755-.233,1.145-.327Z",
    transform: "translate(-314.498 -384.43)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21251",
    "data-name": "Path 21251",
    d: "M393.46,385.934v21.361a49.117,49.117,0,0,1-5.822,3.04V384.48l4.544,1.083C392.616,385.669,393.044,385.789,393.46,385.934Z",
    transform: "translate(-341.606 -384.449)",
    fill: "#108757"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M11.207,11.155A49.742,49.742,0,0,1,0,6.992V0H47.205V6.251a49.654,49.654,0,0,1-10.92,4.468,49.922,49.922,0,0,1-13.371,1.813A50.217,50.217,0,0,1,11.207,11.155Z",
    transform: "translate(13.118 72.964)",
    fill: "#108757"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleAvatar);
export default __webpack_public_path__ + "static/media/maleAvatar.eecf3f939c4019b271742b04a30047b0.svg";
export { ForwardRef as ReactComponent };